import { render } from "./CustomIcon.vue?vue&type=template&id=64817ac8&scoped=true"
import script from "./CustomIcon.vue?vue&type=script&lang=js"
export * from "./CustomIcon.vue?vue&type=script&lang=js"

import "./CustomIcon.vue?vue&type=style&index=0&id=64817ac8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64817ac8"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTooltip});
